// extracted by mini-css-extract-plugin
module.exports = {"Row":"ToggleSwitch_Row_1Jmlz","Label":"ToggleSwitch_Label_3jSId","ToggleButton":"ToggleSwitch_ToggleButton_sGTZH","On":"ToggleSwitch_On_I5z3r","Off":"ToggleSwitch_Off_3w8xq"};